var exports = {
  "k": "container__ZoIZtF",
};

module.exports = exports;
